import React, { useContext } from "react";
import { SkipToMainContentRef } from "./components/SkipLinks";

export const MAIN_HTML_ID = "main-content";
export const Main = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const skipToMainContentRef = useContext(SkipToMainContentRef);
  return (
    <main
      ref={skipToMainContentRef}
      autoFocus={true}
      tabIndex={-1}
      className={className}
      id={MAIN_HTML_ID}
    >
      {children}
    </main>
  );
};
